module.exports = __webpack_public_path__ + "img/日本.a8b52b9b.jpg";